export default __webpack_public_path__ + "static/media/research-woman.aff299c7.svg";